<div class="invoice-container">
  <div class="header">{{ 'Invoice'|translate }}</div>

  <div class="section">
    <div>
      <p class="bold">{{ 'ISSUEDTO'|translate }}:</p>
      <p *ngIf="BuySellOrderData.clientName">{{ BuySellOrderData.clientName }}<br>{{ BuySellOrderData.phoneNumber }}
      </p>
      <p *ngIf="BuySellOrderData.supplierName && !BuySellOrderData.fromAdmin">
        {{ BuySellOrderData.supplierName }}<br>{{ BuySellOrderData.phoneNumber }}
      </p>
      <p *ngIf="BuySellOrderData.isBuy && BuySellOrderData.fromAdmin">
        {{ BuySellOrderData.agentName }}
      </p>
    </div>
    <div>
      <p><span class="bold">{{ 'Date'|translate }} :</span> {{ dateNow|date:'yyyy/MM/dd' }}</p>
    </div>
  </div>

  <div class="section">
    <div *ngIf="BuySellOrderData.isBuy && !BuySellOrderData.fromAdmin || !BuySellOrderData.isBuy">
      <p class="bold">{{ 'PayTO'|translate }}:</p>
      <p>{{ currentUser.name }}<br>{{ currentUser.phoneNumber }}</p>
    </div>
  </div>
  <div *ngFor="let category of categorizedItems">
    <h3>{{category.category}}</h3>
    <table class="m-b-lg">
      <tr>
        <th>{{ 'Code'|translate }}</th>
        <th>{{ 'Description'|translate }}</th>
        <th>{{ 'metersPerRod'|translate }}</th>
        <th>{{ 'TotalQuota'|translate }}</th>
        <th>{{ 'pricePerOne'|translate }}</th>
        <th>{{'Count'|translate }}</th>
        <th>{{'TotalPrice'|translate }}</th>
      </tr>
      <tr *ngFor="let item of category.items">
        <td>{{ item.productCode }}</td>
        <td class="text-start">{{ item.productName }} {{ (item.colorId ? ' - ' + item.colorName : '') }}
        </td>
        <td>
          <ng-container *ngIf="item.metersPerRod">
            {{ item.metersPerRod }} {{ 'Meter'|translate }}
          </ng-container>
        </td>
        <td>
          <ng-container *ngIf="item.totalQuota">
            {{ item.totalQuota }}
          </ng-container>
        </td>
        <td>{{ item.pricePerOne }} {{ 'EGP' | translate }}</td>
        <td>{{ item.count }}</td>
        <td>{{ item.totalPrice }} {{ 'EGP' | translate }}</td>
      </tr>
    </table>
  </div>


  <div class="total">
    <!-- <p><span class="bold">{{'Subtotal'|translate}}:</span> {{BuySellOrderData.total}} {{ 'EGP' | translate}}</p>
    <p><span class="bold">{{'Tax'|translate}} 0%:</span> 0</p> -->
    <p><span class="bold">{{ 'Total'|translate }}:</span> {{ BuySellOrderData.total }} {{ 'EGP' | translate }}</p>
  </div>

  <div class="row btns">
    <div class="col-sm-12">
      <button class="btn orangecolorbtn" (click)="exportPDF()">
        {{ 'exportPDF'|translate }}
      </button>

      <button *ngIf="showClose" mat-button class="btnClose" (click)="Cancel()"> {{ 'Back' | translate }}</button>
    </div>
  </div>
</div>
